module.exports = __webpack_public_path__ + "static/twitter-multiple-accounts-2e95fb65b94b0b78ea04d031ea13dca1.jpg";